import { Quote } from 'lucide-react';
import { praise } from '../data/mock';

export default function Praise() {
  return (
    <section className="relative px-5 md:px-10 lg:px-14 py-24 md:py-32 border-t border-white/5">
      <div className="flex items-center gap-4 mb-12">
        <span className="w-10 h-px bg-[#FF3D2E]" />
        <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-white/70">05 / PRAISE</p>
      </div>

      <div className="max-w-5xl">
        <Quote className="w-12 h-12 text-[#FF3D2E] mb-8" strokeWidth={1.2} />
        <blockquote className="font-display text-3xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight text-white text-balance">
          “{praise.quote}”
        </blockquote>
        <div className="mt-10 flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-neutral-700 to-neutral-900 flex items-center justify-center text-white font-display text-lg border border-white/10">
            {praise.author.split(' ').map((p) => p[0]).join('')}
          </div>
          <div>
            <p className="text-white font-medium">{praise.author}</p>
            <p className="text-[11px] tracking-[0.25em] text-white/55">{praise.role}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
